import React from 'react';
import {
    MimaButton,
    MimaText,
    Modal,
    MimaInput,
    MimaDropdown,

} from '../../components';
import { Formik } from 'formik';

const AddAdmin = ({ onSubmit, closeModal, validationSchema, roles, loading }) => {

    return (
        <Modal closeModal={closeModal}>           
                <Formik
                    initialValues={{
                        firstname: "",
                        lastname: "",
                        email: "",
                        mobile: "",
                        role: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        values,
                        errors,
                        touched,
                    }) => (
                        <>
                            <MimaText variant='subtitleBold' mb={3}>Add Admin</MimaText>
                            <MimaInput
                                name="firstname"
                                labelTitle="First Name"
                                type="text"
                                placeholder="First Name"
                                value={values.firstname}
                                onChange={handleChange('firstname')}
                                onBlur={handleBlur('firstname')}
                                error={errors.firstname}
                                touched={touched.firstname}
                            />
                            <MimaInput
                                name="lastname"
                                labelTitle="Last Name"
                                placeholder="Last Name"
                                value={values.lastname}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.lastname}
                                touched={touched.lastname}
                            />

                            <MimaInput
                                name="email"
                                labelTitle="Email"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.email}
                                touched={touched.email}
                                placeholder="Enter email"
                            />

                            <MimaInput
                                name="mobile"
                                labelTitle="Mobile"
                                value={values.mobile}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.mobile}
                                touched={touched.mobile}
                                placeholder="Enter phone number"
                            />

                            <MimaDropdown
                                placeholder="Select Role"
                                name="role"
                                labelTitle="Role"
                                value={values.role}
                                currentValue={values.role}
                                onBlur={handleBlur('role')}
                                onChange={data => {
                                    setFieldValue('role', data.key);
                                }}
                                data={roles?.map(x => ({ key: x._id, value: x.name }))}
                                error={errors.role}
                                touched={touched.role}
                            />

                            <MimaButton
                                title="Continue"
                                onClick={() => {
                                    handleSubmit();
                                }}
                                width={38}
                                loading={loading}
                            />
                        </>
                    )}
                </Formik> 
        </Modal>
    )
}

export default AddAdmin;